var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "power-a",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "power-c",
    d: "M5.19638164,2.36876081 C5.68070104,2.10333065 6.28849314,2.28077544 6.55392329,2.76509484 C6.81935345,3.24941423 6.64190866,3.85720633 6.15758926,4.12263649 C5.49702099,4.48465944 4.88726727,4.94115986 4.34314575,5.48528137 C1.21895142,8.60947571 1.21895142,13.6747955 4.34314575,16.7989899 C7.46734008,19.9231842 12.5326599,19.9231842 15.6568542,16.7989899 C18.7810486,13.6747955 18.7810486,8.60947571 15.6568542,5.48528137 C15.1432061,4.9716332 14.5710279,4.53601837 13.952659,4.18420429 C13.4726275,3.9110958 13.3048833,3.30055524 13.5779918,2.82052379 C13.8511003,2.34049234 14.4616409,2.17274814 14.9416723,2.44585664 C15.7152811,2.88599264 16.4305349,3.43053487 17.0710678,4.07106781 C20.9763107,7.97631073 20.9763107,14.3079605 17.0710678,18.2132034 C13.1658249,22.1184464 6.83417511,22.1184464 2.92893219,18.2132034 C-0.976310729,14.3079605 -0.976310729,7.97631073 2.92893219,4.07106781 C3.60753123,3.39246877 4.3698941,2.82171544 5.19638164,2.36876081 Z M9.85786438,0 C10.4101491,-1.01453063e-16 10.8578644,0.44771525 10.8578644,1 L10.8578644,8 C10.8578644,8.55228475 10.4101491,9 9.85786438,9 C9.30557963,9 8.85786438,8.55228475 8.85786438,8 L8.85786438,1 C8.85786438,0.44771525 9.30557963,1.01453063e-16 9.85786438,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "power-b",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#power-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#power-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFA0A0",
    mask: "url(#power-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-7 -7)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "power-d",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#power-c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#power-c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7600FF",
    mask: "url(#power-d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-2 -1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.1901220bd711a0de0be35a113ec4624e.svg";
export { ForwardRef as ReactComponent };